import type { SignalDetail } from '../../../types/signals-live';
import { TaxonomyLabelReview } from './TaxonomyLabelReview';

interface SignalDetailModalsProps {
  signal: SignalDetail;
  signalId?: string;
  showDeleteConfirm: boolean;
  isDeleting: boolean;
  showFeedbackModal: boolean;
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
  onCloseFeedback: () => void;
}

export function SignalDetailModals({
  signal,
  signalId,
  showDeleteConfirm,
  isDeleting,
  showFeedbackModal,
  onCancelDelete,
  onConfirmDelete,
  onCloseFeedback,
}: SignalDetailModalsProps) {
  return (
    <>
      {showDeleteConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="mx-4 w-full max-w-md rounded-lg bg-white p-6">
            <h3 className="mb-4 text-lg font-semibold">Confirm Delete</h3>
            <p className="mb-6 text-gray-600">
              Are you sure you want to delete this signal? This action cannot be undone and will also delete all related classifications.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={onCancelDelete}
                className="rounded-lg border border-gray-300 px-4 py-2 hover:bg-gray-50"
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                onClick={onConfirmDelete}
                className="rounded-lg bg-red-600 px-4 py-2 text-white hover:bg-red-700 disabled:opacity-50"
                disabled={isDeleting}
              >
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}

      {signal.classification?.id && showFeedbackModal && (
        <TaxonomyLabelReview
          classification_id={signal.classification.id}
          taxonomy_classification={signal.taxonomy_classification}
          signal_id={signalId}
          signalSummary={signal.summary_detailed || signal.summary}
          signalVerbatim={signal.verbatim}
          customerName={signal.customer_name || signal.customer?.name}
          conductScore={signal.conduct_score ?? signal.classification?.conduct_score}
          onClose={onCloseFeedback}
        />
      )}
    </>
  );
}
